class ProductDescriptionTabs extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const trigger = event.target.closest('.product-description-tabs__trigger');
    if (!trigger || !this.contains(trigger)) return;

    this.querySelectorAll('.product-description-tabs__trigger').forEach((button) => {
      const isSelected = button === trigger;
      button.classList.toggle('is-active', isSelected);
      button.setAttribute('aria-selected', isSelected);
    });

    this.querySelectorAll('.product-description-tabs__panel').forEach((panel) => {
      panel.classList.toggle('hidden', panel.id !== trigger.getAttribute('aria-controls'));
    });
  }
}

customElements.define('product-description-tabs', ProductDescriptionTabs);
